/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Btn_PrevInputs */

const es_walkthrough_btn_prev = /** @type {(inputs: Walkthrough_Btn_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anterior`)
};

const en_walkthrough_btn_prev = /** @type {(inputs: Walkthrough_Btn_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous`)
};

/**
* | output |
* | --- |
* | "Previous" |
*
* @param {Walkthrough_Btn_PrevInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_btn_prev = /** @type {((inputs?: Walkthrough_Btn_PrevInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Btn_PrevInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_btn_prev(inputs)
	return en_walkthrough_btn_prev(inputs)
});
export { walkthrough_btn_prev as "walkthrough.btn_prev" }